import React from "react";
import { Grid2 as Grid, Skeleton } from "@mui/material";
import {
  HeaderContainer,
  OwnerCard,
  OwnerSection,
  TitleContainer,
} from "./styles";
import { BlankImage, CheckOrange } from "../../shared/icons";
import Loader from "../../components/shared-components/Loader";
import { getValidImageUrl } from "../../utils";

interface OwnerNFTsRecord {
  id: string;
  image: string;
  symbol: string;
  name: string;
  amount: string | number;
}

interface Props {
  isLoading: boolean;
  ownerNFTs: OwnerNFTsRecord[];
}

const OwnerNFTs: React.FC<Props> = ({ isLoading, ownerNFTs }) => {
  return (
    <OwnerSection>
      <HeaderContainer>
        <TitleContainer>
          <h2>Digital Assets Owned</h2>
        </TitleContainer>
      </HeaderContainer>
      <Grid container spacing={2}>
        {isLoading ? (
          <Loader />
        ) : ownerNFTs?.length > 0 ? (
          ownerNFTs?.map((nft) => (
            <Grid size={4}>
              <OwnerCard>
                <img
                  src={
                    getValidImageUrl(nft?.image ?? "" ,BlankImage)
                  }
                  onError={(e) => {
                    const target = e.target as HTMLImageElement;
                    target.src = BlankImage;
                  }}
                  alt="nft_image"
                />
                <div className="content">
                  <div className="titleContainer">
                    <p>{nft?.symbol}</p>
                    <CheckOrange />
                  </div>
                  <h5 className="heading" title={nft?.name}>
                    {nft?.name}
                  </h5>
                  <div className="infoBox">
                    <div className="ecoscore">
                      <h6>Amount</h6>
                      <p>{nft?.amount}.0 ETH</p>
                    </div>
                  </div>
                </div>
              </OwnerCard>
            </Grid>
          ))
        ) : (
          <div>No Results Found!</div>
        )}
      </Grid>
    </OwnerSection>
  );
};

export default OwnerNFTs;
